import LazyLoad from "react-lazyload";
import {Link} from 'react-router-dom'
const About = () => {
  return (
    <>
      <div className="breadcrumb">
        <h2>General Information and Prospectus</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li>
          <li>About</li>
          <li>|</li>
          <li>General Information and Prospectus</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/aboutus.png" alt="st francis school, Amritsar" className="img-fluid" /></LazyLoad>
            </div>
            <div className="col-md-8">
              <h3 className="heading">About School</h3>
              <p>This School is owned and administered by the diocese of jalandhar, a registered charitable society that conducts several flourishing schools all over Punjab and certain parts of H.P. This is also a minority institution with all its privileges guaranteed by the<span> Supreme Contitution of India, </span>under the Articles 29, 30 (1). His Excellency the Bishop of jalandhar is the patron of this school and the president of the society.</p>
              <p>The main aim of the school is to provide a sound, value base and emancipation education, designed to train its pupils to live for God and country, through their activities, be it moral, spiritual, intellectual, social or professional. It is student friendly and encourages analytical, creative and independent perspectives, all round development, s positive thinking attitude and sound domain of knowledge positive thinking attitude and sound domain of knowledge with particular applications of it.</p>
            </div>
            <div className="col-md-12 mt-4">
              <h3 className="heading">Important Instruction to Student and Parents</h3>
              <p>The students and their parents are strictly instructed to read and understand all the rules and regulations printed in the school prospectus, school diary and timely circulars issued from the office of the Principal.; any doubt or query pertaining to the rules and regulations can be conveyed or discussed on the day of the following PTM day.</p>
              <p>It is informed to all concerned that the latest copy of the prospectus, the school diary and the latest notified circulars are always available with the office of the Principal and these shall in any case be valid for official reference as wall as for the legal purposes. Ignorance of any of the law/bye-laws shall not be considered as an excuse under any circumstances.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
